module.exports = __webpack_public_path__ + "img/extend_2.903ab5d3.png";